import { render } from "./cart-upsell.vue?vue&type=template&id=0a6b2da1"
import script from "./cart-upsell.vue?vue&type=script&lang=js"
export * from "./cart-upsell.vue?vue&type=script&lang=js"

import "./cart-upsell.vue?vue&type=style&index=0&id=0a6b2da1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__